'use strict';

var GlobalNotificationsTransformerFactory = function GlobalNotificationsTransformerFactory(DataTransformer) {
  function GlobalNotificationsTransformer() {
    DataTransformer.call(this);
    this.targetType = 'global-notifications-mode';
    this.priority = 1;
  }
  GlobalNotificationsTransformer.prototype = Object.create(DataTransformer.prototype);
  GlobalNotificationsTransformer.constructor = GlobalNotificationsTransformer;
  GlobalNotificationsTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.targetType === targetType;
  };
  GlobalNotificationsTransformer.prototype.isCacheable = function () {
    return false;
  };
  GlobalNotificationsTransformer.prototype.getCacheKey = function () {
    return this.sourceType + '-' + this.targetType;
  };
  GlobalNotificationsTransformer.prototype.transform = function (data) {
    return data;
  };
  return GlobalNotificationsTransformer;
};
GlobalNotificationsTransformerFactory.$inject = ['DataTransformerFactory'];
module.exports = GlobalNotificationsTransformerFactory;